<template>
  <nav class="navbar navbar-dark navbar-expand-md bg-dark fixed-top" style="padding:10px 16px;">
    <router-link class="navbar-brand" to="/">
      <a class="navbar-item">
        <img height="28" :src="logo">
      </a>
    </router-link>
    <button class="navbar-toggler" data-toggle="collapse" data-target="#navcol-1">
      <span class="sr-only">Toggle navigation</span><span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navcol-1">
      <ul class="nav navbar-nav">
        <li class="nav-item" role="presentation">
          <router-link class="nav-link text-white" to="/bots">Create Bot</router-link>
        </li>
        <li class="nav-item" role="presentation">
          <router-link class="nav-link text-white" to="/dashboard">Dashboard</router-link>
        </li>
        <li class="nav-item" role="presentation">
          <router-link class="nav-link text-white" to="/pricing">Pricing</router-link>
        </li>
        <li class="nav-item" role="presentation">
          <router-link class="nav-link text-white" to="/user-guide">User Guide</router-link>
        </li>
        <li class="nav-item" role="presentation">
          <router-link class="nav-link text-white" to="/tutorials">Tutorials</router-link>
        </li>
        <li class="nav-item" role="presentation">
          <router-link class="nav-link text-white" to="/templates">Templates</router-link>
        </li>
        <li class="dropdown" v-if="$store.getters.isAuthenticated">
          <a class="dropdown-toggle nav-link" data-toggle="dropdown" aria-expanded="false" href="#">{{$store.getters.userName}}</a>
          <div class="dropdown-menu" role="menu">
            <a class="dropdown-item" role="presentation">Id : {{$store.getters.userId}}</a>
            <a class="dropdown-item btn" role="presentation" @click="logout">Logout</a>
          </div>
        </li>
      </ul>
      <form class="form-inline mr-auto" target="_self">
        <div class="form-group"><label for="search-field"></label></div>
      </form>
      <span class="navbar-text" v-if="!$store.getters.isAuthenticated">
        <router-link to="/login" class="login">Log In</router-link>
      </span>
      <router-link class="btn btn-light action-button" role="button" to="/login" v-if="!$store.getters.isAuthenticated">Sign Up</router-link>
    </div>
  </nav>
</template>

<script>
import logo from '@/assets/img/logo-white-text.png'

export default {
    name: 'Topnav',
    data: function() {
        return {
        user: this.$store.state.user,
        logo: logo
        }
    },
    watch: {
        // everytime a route is changed refresh the activeUser
        //'$route': 'refreshActiveUser'
    },
    methods: {
        logout() {
        this.$store.dispatch('logout')
        if (this.$route.path !== '/')
            this.$router.push('/')
        },
    }
}
</script>

<style>

</style>